export const INSTALLMENT_FEES = {
  1: 0.0499,  // 4,99%
  2: 0.0599, // 5,99%
  3: 0.0699, // 6,99%
  4: 0.0759, // 7,59%
  5: 0.0799, // 7,99%
  6: 0.0899, // 8,99%
};